import type { Money } from '@debtbot/shared';
import { balanceTone, formatMoney } from '../lib/format';

const TONE_CLASS = {
  positive: 'text-positive',
  negative: 'text-negative',
  zero: 'text-hint',
} as const;

export function Amount({
  money,
  withSign = true,
  className = '',
}: {
  money: Money;
  withSign?: boolean;
  className?: string;
}) {
  return (
    <span className={`tabular-nums ${TONE_CLASS[balanceTone(money.amount)]} ${className}`}>
      {formatMoney(money, { withSign })}
    </span>
  );
}
